import React, {useCallback} from 'react';
import _ from 'lodash';
import {connect} from 'react-redux';
import {FemaGoModal} from 'app-ui-componentlibrary';
import ReactHtmlParser from 'react-html-parser';

export const NetworkErrorModal = (props) => {
  const {
    networkErrors,
    handleErrorConfirmation,
    networkErrorPath,
    errorTitle,
    errorMessage,
  } = props;
  const networkErrorEntity = _.get(networkErrors, networkErrorPath, {});
  const networkErrorEntityErrors = _.get(networkErrorEntity, 'error', {});
  const confirmAction = useCallback(() => {
    handleErrorConfirmation && handleErrorConfirmation(networkErrorEntityErrors);
  }, [handleErrorConfirmation, networkErrorEntityErrors]);
  return (
    <FemaGoModal
      type={_.get(networkErrorEntityErrors, 'alertType', 'alert')}
      size="small"
      title={_.get(networkErrorEntityErrors, 'title', errorTitle)}
      className="modal-title"
      open={networkErrorEntity.hasError}
      hideCancel={true}
      buttonText={_.get(networkErrorEntityErrors, 'buttonText', 'Refresh')}
      confirmAction={confirmAction}
    >
      {ReactHtmlParser(_.get(networkErrorEntityErrors, 'text', errorMessage))}
    </FemaGoModal>
  );
};

export const mapStateToProps = (state) => ({
  networkErrors: _.get(state, 'dynamicComponent.networkErrors'),
});

export default connect(mapStateToProps, null)(NetworkErrorModal);
